import React from 'react';
import { Link } from 'react-router-dom';
import TestimonialPost from '../Posts/TestimonialPost';
import getTestimonialsData from '../../PostData/testimonialsData';

const TestimonialsSection = () => {
    const testimonialsData = getTestimonialsData.slice(0, 2);

    return (
        testimonialsData.length !== 0 && <section className="testimonials" id="testimonials">
            <div className="container">
                <div className="text_center mbBig">
                    <h2 className="headingSecondary">People Are Happy</h2>
                </div>

                {testimonialsData.map(test => <TestimonialPost testimonial={test} key={test.id}></TestimonialPost>)}

            </div> {/* Container */}

            <div className="text_center mtBig">
                <Link to="/testimonials" className="btn-text">Read all stories &rarr;</Link>
            </div>
        </section> // Testimonials
    );
};

export default TestimonialsSection;